module.exports = __webpack_public_path__ + "img/tarj1-2.6c182245.png";